import { flatMap, groupBy, maxBy } from 'lodash'

import { LibraryEntry } from '../models'

export function getLatestRateCardVersionEntries<T extends LibraryEntry>(
  isLatestRateCardItems: boolean,
  entries: T[] = []
): T[] {
  if (!entries) return []
  if (!isLatestRateCardItems) return entries

  const grouped = groupBy(entries, (i) => `${i.discipline.id}|${i.rateCardVersion.identity.id}`)

  return flatMap(grouped, (group) => {
    const maxVersion = maxBy(group, (i) => i.rateCardVersion.version)!.rateCardVersion.version
    return group.filter((i) => i.rateCardVersion.version === maxVersion)
  })
}
